import { render, staticRenderFns } from "./OsLoader.vue?vue&type=template&id=55783e93&scoped=true&"
import script from "./OsLoader.vue?vue&type=script&lang=js&"
export * from "./OsLoader.vue?vue&type=script&lang=js&"
import style0 from "./OsLoader.vue?vue&type=style&index=0&id=55783e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55783e93",
  null
  
)

export default component.exports